<ng-container>
  <h1 class="h3 mb-3"><strong>List</strong> Claims</h1>
</ng-container>
<div  class="merchant-list-layout">
  <div class="header-action-item">
    <button class="btn btn-primary"(click)="reloadPage();">
      <i class="bi bi-arrow-clockwise"></i>
    </button>
  </div>
  <table-view
    [isLoading] = isScreenLoading
    [tableConfiguration] = "tableConfiguration">
  </table-view>
</div>
